import { loader } from "./actions.tsx";
import ValidatePage from "./validate.tsx";

export default {
  path: "/validate/:id",
  loader,
  Component: ValidatePage,
};
